
import { Component, Vue, Prop} from 'vue-property-decorator';

import StepBase from "../StepBase.vue";
import { stepInfoType } from "@/types/Application";
import WillSearchCheck from "./WillSearchCheck.vue";
import FinalizeAssetValues from "./FinalizeAssetValues.vue";


@Component({
    components:{
        StepBase,
        WillSearchCheck,
        FinalizeAssetValues        
    }
})
export default class OverviewStep extends Vue {
    
    @Prop({required: true})
    step!: stepInfoType;

};
